module.exports = __webpack_public_path__ + "media/images/page/top/top_img_08-ad5d4059ce859cad17a29783a60b3967.png";